export default "__VITE_ASSET__By3fOVTv__"